import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">用户热评</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <span className="text-sm font-semibold text-foreground-800 block whitespace-nowrap overflow-hidden text-ellipsis">{comment.name}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}